import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import BusAssignmentScheduleForm from './BusAssignmentScheduleForm';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { postBusAssignmentSchedule } from '../../../../actions/bus/BusAssignmentSchedule';
import { tzNormalizeDate } from '../../../../utils/date';

const NewBusAssignmentSchedule = ({
  breadcrumbs,
  dispatchPostBusAssignmentSchedule,
}) => {
  const onSubmit = (formValues) => {
    const startDate = tzNormalizeDate({
      date: formValues.startDate,
    });

    const endDate = tzNormalizeDate({
      date: formValues.endDate,
    });

    if (moment(startDate).isAfter(moment(endDate))) {
      toastr.error(
        'Error',
        'La fecha de inicio no puede ser mayor a la fecha de fin',
      );
      return;
    }

    const newFormValues = {
      circuitIdList: formValues.circuitList.map((circuit) => circuit.value),
      busIdList: formValues.busList.map((bus) => bus.value),
      startDate: formValues.startDate,
      endDate: formValues.endDate,
    };

    dispatchPostBusAssignmentSchedule(newFormValues);
  };

  const content = <BusAssignmentScheduleForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Asignación de Ruta"
      subtitle="Crear nueva asignación de ruta"
      content={content}
    />
  );
};

NewBusAssignmentSchedule.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBusAssignmentSchedule: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Asignaciones de Rutas',
      href: '/bus/bus-assignment-schedules',
    },
    {
      text: 'Nueva',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostBusAssignmentSchedule: postBusAssignmentSchedule,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewBusAssignmentSchedule);
